export let BridgeProductManagementPage;

if (typeof window === 'undefined' || window.isServerSide) {
    BridgeProductManagementPage = null;
} else {
    BridgeProductManagementPage = require('./BridgeProductManagementApp').default;
}